<template>

  <popup
    :button-style="style"
    :heading="heading"
    :show-text="showText"
    button-size="mini"
    :disableButton="!isManager('property|finance') || renewalDays > 365 || renewal.saved"
    :button-text="buttonText"
    :button-icon="icon"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <renewal :tenancy-data="tenancy" :site-data="site" @change="renewalChanges" />

  </popup>

</template>


<script>



import moment from 'moment'

import ArrayMixins from '@/mixins/ArrayMixins'
import PostMixins from '@/mixins/PostMixins'
import NumberMixins from '@/mixins/NumberMixins'

import Renewal from '@/components/property/Renewal'

export default {
  mixins: [ArrayMixins, PostMixins, NumberMixins],

  components: {
    Renewal
  },

  props: {

    tenancyData: {
      type: [Object, Array],
      required: true
    },

    showText: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    renewalChanges (renewal, index) {
      this.renewal = renewal
    },

    onSuccess (ren) {
      this.renewal = this.clone(ren)
      this.$emit('change', this.renewal)

      this.reset = this.clone(ren)

    },


    onSaveDialog () {
      this.saveForm(this, '/tenancy/renewal', null, this.renewal, 'New Renewal for ' + this.site.siteName, this.onSucces, null, true, ['tenancy-expiry-table', 'renewalTable'])
    },


    onCloseDialog () {
      this.renewal = this.reset
    }
  },



  computed: {

    heading: function () {
      return 'Tenancy ' + (this.renewal.expiry
        ? (this.renewal.term > 0
          ? this.addSuffix(this.renewal.term, false) + ' Renewal'
          : 'Update')
        : 'Creation') + ': ' + this.site.siteName

    },

    buttonText: function () {
      return (this.renewalDays > 0 ? 'Renews in ' : (this.renewalDays ? 'Expired ' : '')) + this.fromNow
    },

    renewalDays: function () {

      if (this.renewal && this.renewal.expiry) {
        return moment(this.renewal.expiry).diff(moment(), 'days')
      } else {
        return null
      }

    },


    fromNow: function () {
      if (this.renewal && this.renewal.expiry) {
        return moment(this.renewal.expiry).fromNow()
      } else {
        return 'Add First Renewal'
      }
    },



    style: function () {
      var days = this.renewalDays

      if (days) {

        if (days <= 30) {
          return 'danger'
        }

        if (days > 30 && days <= 120) {
          return 'warning'
        }

        if (days > 120 && days <= 180) {
          return 'primary'
        }

        if (days > 180 && days <= 270) {
          return 'success'
        }

        if (days > 270) {
          return 'info'
        }
      }

      return 'text'
    },



    icon: function () {
      var days = this.renewalDays

      if (days) {

        if (days <= 90) {
          return 'fa fa-exclamation-circle'
        }

        if (days > 90 && days <= 120) {
          return 'fa fa-info-circle'
        }

        if (days > 120 && days <= 180) {
          return 'fa fa-bell'
        }

        if (days > 180 && days <= 270) {
          return 'fa fa-clock'
        }

        if (days > 270) {
          return 'fa fa-calendar-alt'
        }
      }

      return 'fa fa-calendar-alt'
    }

  },



  watch: {

    tenancyData: function (tenancy) {
      this.tenancy = tenancy
      this.renewal = this.tenancy.renewal ? this.clone(this.tenancy.renewal) : this.getTableStruct('tenancy_renewals')
      this.owner = this.tenancy.owner

      if (!this.renewal.tenancy_id || this.renewal.tenancy_id !== this.tenancy.id) {
        this.renewal.tenancy_id = this.tenancy.id
      }
    },

    renewal: function (ren) {
      this.$emit('change', ren)
    },

    siteData: function (site) {
      this.site = site
    }

  },



  data () {

    return {
      tenancy: this.tenancyData,
      renewal: this.tenancyData && this.tenancyData.renewal ? this.clone(this.tenancyData.renewal) : this.getTableStruct('tenancy_renewals'),
      site: this.siteData
        ? this.siteData
        : (this.tenancyData && this.tenancyData.site
          ? this.tenancyData.site
          : {}),
      owner: this.tenancyData.owner,
      reset: this.tenancyData.renewal ? this.clone(this.tenancyData.renewal) : {}
    }

  }

}

</script>
